/* Şeffaf header: kaydırınca zemine döner; header yüksekliğini CSS'e bildirir. */
(function () {
  var body = document.body;
  if (!body.classList.contains('lvp-seffaf')) return;
  var header = document.querySelector('.section-header');
  function boyu() {
    if (header) document.documentElement.style.setProperty('--lvp-header-h', header.offsetHeight + 'px');
  }
  function durum() {
    body.classList.toggle('lvp-scrolled', window.scrollY > 24);
  }
  boyu(); durum();
  window.addEventListener('resize', boyu);
  window.addEventListener('scroll', durum, { passive: true });
})();

/* Vitrin okları: şeridi kart genişliği kadar kaydırır. */
document.querySelectorAll('[data-lvp-kaydir]').forEach(function (btn) {
  btn.addEventListener('click', function () {
    var kok = btn.closest('[data-lvp-vitrin]') || btn.closest('.lvp-vitrin');
    var serit = kok.querySelector('.lvp-vitrin__panel.aktif [data-lvp-serit]') || kok.querySelector('[data-lvp-serit]');
    var kart = serit.querySelector('.lvp-vitrin__kart, .lvp-yorum');
    var adim = kart ? kart.offsetWidth + 16 : 320;
    serit.scrollBy({ left: adim * Number(btn.dataset.lvpKaydir) * 2, behavior: 'smooth' });
  });
});

/* Sekmeler: paneli değiştir. Noktalar: kaydırma konumunu izle. */
document.querySelectorAll('[data-lvp-vitrin]').forEach(function (kap) {
  kap.querySelectorAll('[data-lvp-sekme]').forEach(function (sekme) {
    sekme.addEventListener('click', function () {
      kap.querySelectorAll('[data-lvp-sekme]').forEach(function (s) { s.classList.remove('aktif'); });
      kap.querySelectorAll('[data-lvp-panel]').forEach(function (p) { p.classList.remove('aktif'); });
      sekme.classList.add('aktif');
      var panel = kap.querySelector('[data-lvp-panel="' + sekme.dataset.lvpSekme + '"]');
      if (panel) panel.classList.add('aktif');
      var baslik = kap.querySelector('[data-lvp-vitrin-baslik]');
      if (baslik) baslik.textContent = sekme.textContent.trim();
      var buton = kap.querySelector('[data-lvp-vitrin-buton]');
      if (buton && sekme.dataset.lvpUrl) buton.setAttribute('href', sekme.dataset.lvpUrl);
      var metin = kap.querySelector('[data-lvp-vitrin-metin]');
      if (metin) metin.textContent = sekme.dataset.lvpMetin || '';
    });
  });
  kap.querySelectorAll('[data-lvp-serit]').forEach(function (serit) {
    var noktalar = serit.parentElement.querySelector('[data-lvp-noktalar]');
    var kartlar = serit.querySelectorAll('.lvp-vitrin__kart, .lvp-yorum');
    if (!noktalar || kartlar.length < 2) return;
    kartlar.forEach(function (k, i) {
      var n = document.createElement('button');
      n.type = 'button';
      n.className = 'lvp-vitrin__nokta' + (i === 0 ? ' aktif' : '');
      n.setAttribute('aria-label', (i + 1) + '. ürün');
      n.addEventListener('click', function () { serit.scrollTo({ left: k.offsetLeft - serit.offsetLeft, behavior: 'smooth' }); });
      noktalar.appendChild(n);
    });
    serit.addEventListener('scroll', function () {
      var adim = kartlar[0].offsetWidth + 16;
      var i = Math.min(kartlar.length - 1, Math.round(serit.scrollLeft / adim));
      noktalar.querySelectorAll('.lvp-vitrin__nokta').forEach(function (n, j) {
        n.classList.toggle('aktif', j === i);
      });
    }, { passive: true });
  });
});

/* Mega menü hover kodu theme.liquid içine SATIR İÇİ taşındı (2026-09-01).
   Neden: bu dosya defer'li; yavaş ağda menü görünür olduktan sonra saniyelerce
   hover'sız kalıyordu (ölçüm: menü 4,2 sn'de ekranda, hover 6,4 sn'de aktif).
   Satır içi kod menüyle aynı anda hazır. Buraya GERİ TAŞIMA. */

/* Hover tazeleme (2026-08-31): tarayıcı, imleç sabitken sayfa kaydırıldığında
   :hover'ı yeniden hesaplamaz (Safari hiç, Chrome gecikmeli). Koleksiyonda
   kaydırarak kartın "üstüne gelen" kullanıcı sepete ekle butonunu göremiyordu.
   İmleç konumu izlenir; kaydırma bitince altındaki karta .lvp-hover verilir,
   CSS bunu :hover ile eş tutar. Yalnız ince imleçli cihazlarda çalışır. */
if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
  (function () {
    var mx = -1, my = -1, rafBekliyor = false;
    document.addEventListener('mousemove', function (e) { mx = e.clientX; my = e.clientY; }, { passive: true });
    function tazele() {
      rafBekliyor = false;
      if (mx < 0) return; /* imleç konumu henüz bilinmiyor (ilk olaydan önce) */
      var eski = document.querySelectorAll('.lvp-hover');
      var alt = document.elementFromPoint(mx, my);
      var kart = alt && alt.closest ? alt.closest('.card-wrapper') : null;
      eski.forEach(function (e) { if (e !== kart) e.classList.remove('lvp-hover'); });
      if (kart) kart.classList.add('lvp-hover');
    }
    window.addEventListener('scroll', function () {
      if (rafBekliyor) return;
      rafBekliyor = true;
      requestAnimationFrame(tazele);
    }, { passive: true });
    /* Gerçek hover devralınca sınıfı bırak — çifte durum kalmasın */
    document.addEventListener('mousemove', function () {
      var e = document.querySelector('.lvp-hover');
      if (e) e.classList.remove('lvp-hover');
    }, { passive: true });
  })();
}

/* Footer akordeon: mobilde başlıklı footer sütunları dokununca açılır. */
if (window.matchMedia('(max-width: 749px)').matches) {
  document.querySelectorAll('.footer .footer-block.grid__item').forEach(function (blok) {
    var baslik = blok.querySelector('.footer-block__heading');
    if (!baslik || !baslik.textContent.trim()) return;
    blok.classList.add('lvp-akordeon');
    baslik.setAttribute('role', 'button');
    baslik.setAttribute('tabindex', '0');
    baslik.setAttribute('aria-expanded', 'false');
    function degistir() {
      var acik = blok.classList.toggle('acik');
      baslik.setAttribute('aria-expanded', acik ? 'true' : 'false');
    }
    baslik.addEventListener('click', degistir);
    baslik.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); degistir(); }
    });
  });
}

/* Ürün sayfası: satın alma butonu ekrandan çıkınca yapışkan çubuk belirir. */
(function () {
  var cubuk = document.querySelector('[data-lvp-yapiskan]');
  if (!cubuk) return;
  var hedef = document.querySelector('.product-form__submit');
  if (!hedef) { cubuk.classList.add('gorunur'); return; }
  new IntersectionObserver(function (girisler) {
    cubuk.classList.toggle('gorunur', !girisler[0].isIntersecting);
  }, { threshold: 0 }).observe(hedef);
})();

/* Hikaye bloğu videosu: yalnız etkileşimde oynar (kullanıcı kararı, 2026-08-26).
   Masaüstü  → imleç üzerine gelince oynar, ayrılınca durur.
   Dokunmatik→ dokununca oynar/durur (hover yok).
   Liquid tarafında autoplay kapalı; JS çalışmazsa video sabit kare kalır. */
(function () {
  /* DİKKAT (2026-09-01): manifesto videosu (.lvp-manifesto__video) BURAYA
     EKLENMEZ — o, gec-yukle sistemiyle görünür olunca kendiliğinden oynayan
     sürekli döngüdür (2026-08-29 hız tasarımı); hover-durdur bağlanırsa
     imleç değince döngü kalıcı durur. Hover-oynat yalnız hikaye videoları. */
  var videolar = document.querySelectorAll('.lvp-hblok__video');
  if (!videolar.length) return;

  var imlecVar = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  Array.prototype.forEach.call(videolar, function (video) {
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');

    function oynat() { var s = video.play(); if (s && s.catch) s.catch(function () {}); }
    function durdur() { if (!video.paused) video.pause(); }

    if (imlecVar) {
      video.addEventListener('mouseenter', oynat);
      video.addEventListener('mouseleave', durdur);
      /* klavyeyle gezenler de görebilsin */
      video.tabIndex = 0;
      video.addEventListener('focus', oynat);
      video.addEventListener('blur', durdur);
    } else {
      /* Dokunmatikte hover yok. Sadece dokununca oynatmak denendi ama video
         sabit (ve bulanık ön kare) görünüp kullanıcı fark etmiyordu; bu yüzden
         görüş alanına girince oynuyor, çıkınca duruyor. Dokunma da açıp
         kapatabiliyor. (2026-08-26) */
      video.style.cursor = 'pointer';
      video.addEventListener('click', function () {
        if (video.paused) { oynat(); } else { durdur(); }
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (girisler) {
          girisler.forEach(function (giris) {
            if (giris.isIntersecting) { oynat(); } else { durdur(); }
          });
        }, { threshold: 0.4 }).observe(video);
      } else {
        oynat();
      }
    }
  });
})();

/* [A4] Görsellerin yumuşak açılışı (2026-08-27).
   Sınıf yükleme anında ekleniyor. Kritik (eager/fetchpriority=high) görseller
   hariç — LCP'yi geciktirmemek için. JS çalışmazsa görseller normal görünür,
   hiçbir şey gizlenmez. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  function isaretle(img) {
    if (img.dataset.lvpBelirdi) return;
    img.dataset.lvpBelirdi = '1';
    img.classList.add('lvp-gorsel-belirdi');
  }
  function kur(img) {
    if (img.getAttribute('loading') === 'eager') return;
    if (img.getAttribute('fetchpriority') === 'high') return;
    if (img.complete && img.naturalWidth > 0) return; /* önbellekten geldi, animasyona gerek yok */
    img.addEventListener('load', function () { isaretle(img); }, { once: true });
  }
  document.querySelectorAll('img').forEach(kur);
  /* sonradan eklenen görseller (varyant değişimi, filtre yenilemesi) */
  if ('MutationObserver' in window) {
    new MutationObserver(function (kayitlar) {
      kayitlar.forEach(function (k) {
        k.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.tagName === 'IMG') kur(n);
          else if (n.querySelectorAll) n.querySelectorAll('img').forEach(kur);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();

/* [B3] Çıpa çubuğunda bulunulan bölümü işaretle (2026-08-27).
   Menü sayfası 10.143px; kullanıcı hangi bölümde olduğunu kaybediyordu. */
(function () {
  var baglantilar = [].slice.call(document.querySelectorAll('.lvp-cipalar__link'));
  if (!baglantilar.length || !('IntersectionObserver' in window)) return;

  var eslesme = [];
  baglantilar.forEach(function (a) {
    var href = a.getAttribute('href') || '';
    if (href.charAt(0) !== '#' || href.length < 2) return;
    var hedef = document.getElementById(href.slice(1));
    if (hedef) eslesme.push({ link: a, hedef: hedef });
  });
  if (!eslesme.length) return;

  var gorunur = [];
  function tazele() {
    baglantilar.forEach(function (a) { a.classList.remove('aktif'); a.removeAttribute('aria-current'); });
    if (!gorunur.length) return;
    /* sayfada en yukarıda duran görünür bölüm aktif sayılır */
    gorunur.sort(function (a, b) { return a.getBoundingClientRect().top - b.getBoundingClientRect().top; });
    var e = eslesme.find(function (x) { return x.hedef === gorunur[0]; });
    if (e) { e.link.classList.add('aktif'); e.link.setAttribute('aria-current', 'true'); }
  }

  var gozlemci = new IntersectionObserver(function (girisler) {
    girisler.forEach(function (g) {
      var i = gorunur.indexOf(g.target);
      if (g.isIntersecting) { if (i === -1) gorunur.push(g.target); }
      else if (i !== -1) { gorunur.splice(i, 1); }
    });
    tazele();
  }, { rootMargin: '-30% 0px -55% 0px', threshold: 0 });

  eslesme.forEach(function (x) { gozlemci.observe(x.hedef); });
})();

/* Kapak kaydırma butonu: bir alttaki bölüme yumuşakça iner (2026-08-28).
   Önceden dekoratif bir span'di, tıklanmıyordu. Yapışkan header varsa
   yüksekliği kadar pay bırakılıyor ki bölüm başlığı altında kalmasın. */
(function () {
  var butonlar = document.querySelectorAll('[data-lvp-kapak-kaydir]');
  if (!butonlar.length) return;

  function headerYuksekligi() {
    var h = document.querySelector('.section-header');
    if (!h) return 0;
    var k = getComputedStyle(h).position;
    /* yalnız sayfayla birlikte kaymayan header pay gerektirir */
    return (k === 'sticky' || k === 'fixed') ? h.offsetHeight : 0;
  }

  Array.prototype.forEach.call(butonlar, function (buton) {
    buton.addEventListener('click', function () {
      var kapak = buton.closest('.lvp-kapak') || buton.parentElement;
      var bolum = kapak.closest('.shopify-section') || kapak;
      /* bir sonraki GÖRÜNÜR bölümü bul; boş/gizli olanları atla */
      var sonraki = bolum.nextElementSibling;
      while (sonraki) {
        var k = sonraki.getBoundingClientRect();
        if (k.height > 40 && getComputedStyle(sonraki).display !== 'none') break;
        sonraki = sonraki.nextElementSibling;
      }
      var hedef;
      if (sonraki) {
        hedef = sonraki.getBoundingClientRect().top + window.scrollY - headerYuksekligi();
      } else {
        /* sonraki bölüm yoksa kapak boyu kadar in */
        hedef = kapak.getBoundingClientRect().bottom + window.scrollY - headerYuksekligi();
      }
      window.scrollTo({ top: Math.max(0, Math.round(hedef)), behavior: 'smooth' });
    });
  });
})();

/* Başa dön (2026-08-28).
   İki ekran kaydırılınca beliriyor. Sağ alt köşenin zemini sayfadan sayfaya
   değiştiği için (krem / koyu yeşil / koyu kahve) arkadaki rengi ölçüp
   metni ona göre çeviriyor — sabit renk her zeminde okunmuyordu. */
(function () {
  var buton = document.querySelector('[data-lvp-basa-don]');
  if (!buton) return;

  var yumusak = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function renkAyristir(c) {
    var m = (c || '').match(/[\d.]+/g);
    if (!m || m.length < 3) return null;
    if (m.length > 3 && Number(m[3]) === 0) return null; /* saydam */
    return { r: +m[0], g: +m[1], b: +m[2] };
  }

  /* Butonun arkasındaki en yakın dolu zemini bul */
  function arkaZemin() {
    var k = buton.getBoundingClientRect();
    var x = Math.round(k.left + k.width / 2);
    var y = Math.round(k.top + k.height / 2);
    buton.style.pointerEvents = 'none';
    var oge = document.elementFromPoint(x, y);
    buton.style.pointerEvents = '';
    while (oge) {
      var renk = renkAyristir(getComputedStyle(oge).backgroundColor);
      if (renk) return renk;
      oge = oge.parentElement;
    }
    return { r: 255, g: 255, b: 255 };
  }

  function zeminUyarla() {
    var z = arkaZemin();
    /* algılanan parlaklık; 140 altı koyu sayılıyor */
    var parlaklik = (z.r * 299 + z.g * 587 + z.b * 114) / 1000;
    buton.classList.toggle('lvp-basa-don--koyu', parlaklik < 140);
  }

  var bekleyen = false;
  var gecikme;
  function tazele() {
    if (bekleyen) return;
    bekleyen = true;
    window.requestAnimationFrame(function () {
      bekleyen = false;
      var esik = window.innerHeight * 2;
      buton.classList.toggle('gorunur', window.scrollY > esik);
      /* Zemin her tazelemede ölçülüyor: görünürlük koşuluna bağlanınca
         ilk ölçüm bayat kalıp koyu bölümde açık renk metin bırakıyordu.
         Kaydırma durduktan sonra bir kez daha ölçülüyor — anlık (instant)
         kaydırmalarda düzen tam oturmadan ölçüm alınabiliyor. */
      zeminUyarla();
      clearTimeout(gecikme);
      gecikme = setTimeout(zeminUyarla, 140);
    });
  }

  buton.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: yumusak ? 'smooth' : 'auto' });
  });

  window.addEventListener('scroll', tazele, { passive: true });
  window.addEventListener('resize', tazele);
  /* Geç yüklenen görseller düzeni kaydırıyor; kaydırma durmuşken bu olursa
     butonun altındaki zemin değişip ölçüm bayatlıyordu (ürün sayfasında
     koyu bölümden beyaza kayınca metin okunmaz hale geliyordu). Görsel
     yüklenmelerini yakalamak için yayılma aşamasında dinleniyor. */
  document.addEventListener('load', tazele, true);
  window.addEventListener('load', tazele);
  tazele();
})();

/* Çıpa çubuğunu gerçekten yapıştır (2026-08-29).
   position:sticky işe yaramıyordu: çubuk kendi Shopify bölümünün içinde ve o
   bölüm yalnız ~61px yüksekliğinde, yani sticky'nin kayacağı alan yok
   (ölçüm: sayfa kaydıkça çubuğun tepesi -6414px'e gidiyordu).
   IntersectionObserver da çalışmadı: sıfır yükseklikli gözcü hiçbir zaman
   kesişim durumu değiştirmediği için geri çağrı bir daha tetiklenmiyordu.
   Bu yüzden düz bir kaydırma dinleyicisi kullanılıyor — davranışı öngörülebilir.
   Çubuk ekranın üstünden çıkınca fixed'e geçiyor; yerine aynı yükseklikte bir
   boşluk konuyor ki sayfa zıplamasın. */
(function () {
  var cubuk = document.querySelector('.lvp-cipalar-dis');
  if (!cubuk) return;

  var yer = document.createElement('div');
  yer.className = 'lvp-cipalar-yer';
  cubuk.parentNode.insertBefore(yer, cubuk);

  var esik = 0;
  function esigiOlc() {
    /* çubuk fixed'deyken kendi konumu okunamaz; yer tutucununki geçerli */
    var hedef = cubuk.classList.contains('yapisti') ? yer : cubuk;
    esik = hedef.getBoundingClientRect().top + window.scrollY;
  }

  var bekleyen = false;
  function tazele() {
    if (bekleyen) return;
    bekleyen = true;
    window.requestAnimationFrame(function () {
      bekleyen = false;
      var yapissin = window.scrollY > esik;
      if (yapissin === cubuk.classList.contains('yapisti')) return;
      if (yapissin) {
        yer.style.height = cubuk.offsetHeight + 'px';
        yer.classList.add('aktif');
        cubuk.classList.add('yapisti');
      } else {
        cubuk.classList.remove('yapisti');
        yer.classList.remove('aktif');
        yer.style.height = '';
      }
    });
  }

  esigiOlc();
  window.addEventListener('scroll', tazele, { passive: true });
  window.addEventListener('resize', function () { esigiOlc(); tazele(); });
  window.addEventListener('load', function () { esigiOlc(); tazele(); });
  tazele();
})();

/* ────────────────────────────────────────────────────────────────────────
   Geciktirmeli video: preload="none" ile işaretlenmiş videoları ancak
   görünür alana yaklaşınca indirip başlatır.

   Neden: manifesto videosu katlamanın çok altında olmasına rağmen autoplay
   yüzünden sayfa açılır açılmaz 3,4 MB iniyordu ve kapak videosuyla bandı
   paylaşıp LCP'yi 6656 ms'ye çıkarıyordu (ölçüm 2026-08-29).

   rootMargin 200px: kullanıcı bölüme varmadan önce yükleme başlasın ki
   ekrana geldiğinde hareket zaten sürüyor olsun.
   ──────────────────────────────────────────────────────────────────────── */
(function () {
  var videolar = document.querySelectorAll('video[data-gec-yukle]');
  if (!videolar.length) return;

  function baslat(video) {
    if (video.dataset.gecYuklendi) return;
    video.dataset.gecYuklendi = '1';
    video.preload = 'auto';
    video.load();
    var sozu = video.play();
    /* Bazı tarayıcılar sessiz videoda bile reddedebiliyor; poster kalır. */
    if (sozu && sozu.catch) sozu.catch(function () {});
  }

  /* ── Kapak videosu: görünür alanda ama posteri beklemeli ──────────────
     Kapak zaten ekranda olduğu için gözlemci anında tetiklenir ve hiçbir
     şey kazanılmaz. Burada beklenen şey görünürlük değil, POSTER'in inmesi:
     poster boyandığı an LCP tamamlanır, video ondan sonra başlayabilir.

     Poster zaten <link rel="preload"> ile öncelikli indiriliyor; aynı adresi
     bir Image nesnesiyle istemek önbellekten döner ve inme anını haber verir.
     Poster hiç gelmezse video sonsuza dek beklemesin diye 4 sn emniyet payı.
     ──────────────────────────────────────────────────────────────────── */
  var posterBekleyen = [];
  Array.prototype.forEach.call(videolar, function (v) {
    if (v.hasAttribute('data-poster-bekle')) posterBekleyen.push(v);
  });

  posterBekleyen.forEach(function (video) {
    var bitti = false;
    function birKez() {
      if (bitti) return;
      bitti = true;
      baslat(video);
    }
    if (video.poster) {
      var gorsel = new Image();
      gorsel.onload = birKez;
      gorsel.onerror = birKez;
      gorsel.src = video.poster;
    }
    window.setTimeout(birKez, 4000);
  });

  var kalanlar = Array.prototype.filter.call(videolar, function (v) {
    return !v.hasAttribute('data-poster-bekle');
  });
  if (!kalanlar.length) return;

  if (!('IntersectionObserver' in window)) {
    /* Gözlemci yoksa hemen başlat — eski tarayıcıda hareket kaybolmasın. */
    kalanlar.forEach(baslat);
    return;
  }

  var gozlemci = new IntersectionObserver(
    function (girdiler) {
      girdiler.forEach(function (g) {
        if (!g.isIntersecting) return;
        baslat(g.target);
        gozlemci.unobserve(g.target);
      });
    },
    { rootMargin: '200px 0px' }
  );

  kalanlar.forEach(function (v) { gozlemci.observe(v); });
})();


/* Yorum şeridi kendiliğinden YAVAŞ akar (2026-09-01, kullanıcı isteği:
   "kaymayınca anlamsız kalıyor"). Kurallar:
   - Kartlar bir kez klonlanır (aria-hidden) → uçtan uca sarımsız sonsuz döngü.
   - İmleç üstündeyken ve dokunuş/ok/tekerlek sonrası 5 sn DURUR; kullanıcı
     etkileşimi her zaman kazanır. prefers-reduced-motion'da hiç çalışmaz.
   - Akarken scroll-snap kapatılır (.lvp-akan) — mandatory snap sürüklenmeyle
     kavga edip titretiyor; kullanıcı devralınca snap geri gelir.
   - Bölüm ekranda değilken rAF boşa akıtmaz (IntersectionObserver).
   - Tema düzenleyicisinde (designMode) kapalı — klonlar editörü şaşırtmasın. */
(function () {
  if (window.Shopify && Shopify.designMode) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var serit = document.querySelector('.lvp-yorumlar__serit');
  if (!serit || serit.children.length < 2) return;

  [].slice.call(serit.children).forEach(function (k) {
    var c = k.cloneNode(true);
    c.setAttribute('aria-hidden', 'true');
    serit.appendChild(c);
  });

  var HIZ = 22; /* px/SANİYE — kare hızından bağımsız (120 Hz ekranda da aynı tempo) */
  var beklemeBitisi = Date.now() + 1500; /* sayfa otururken kısa bekleme */
  var imlecUstunde = false;
  var gorunur = false;
  var konum = null; /* kesirli scrollLeft biriktirici */

  function durdur(ms) { beklemeBitisi = Date.now() + ms; konum = null; serit.classList.remove('lvp-akan'); }
  ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) {
    serit.addEventListener(ev, function () { durdur(5000); }, { passive: true });
  });
  serit.addEventListener('mouseenter', function () { imlecUstunde = true; durdur(0); });
  serit.addEventListener('mouseleave', function () { imlecUstunde = false; durdur(1200); });
  var kap = serit.closest('[data-lvp-vitrin]');
  if (kap) kap.querySelectorAll('[data-lvp-kaydir]').forEach(function (b) {
    b.addEventListener('click', function () { durdur(6000); });
  });

  new IntersectionObserver(function (g) { gorunur = g[0].isIntersecting; }).observe(serit);

  var oncekiZaman = null;
  (function adim(zaman) {
    var gecen = oncekiZaman === null ? 0 : Math.min(zaman - oncekiZaman, 100);
    oncekiZaman = zaman;
    if (gorunur && !imlecUstunde && Date.now() > beklemeBitisi) {
      serit.classList.add('lvp-akan');
      if (konum === null) konum = serit.scrollLeft;
      konum += HIZ * gecen / 1000;
      var yari = serit.scrollWidth / 2;
      if (konum >= yari) konum -= yari;
      serit.scrollLeft = konum;
    }
    requestAnimationFrame(adim);
  })(performance.now());
})();


/* bfcache koruması (2026-09-01, kullanıcı: "bazen sayfa yenilemeden çalışmıyor").
   Geri/ileri gezinmede tarayıcı sayfayı bellekten geri getirir (pageshow
   persisted=true); açık kalmış menü, yarım kalmış akış sınıfı, oynar durumda
   donmuş video gibi bayat durumlar temizlenir. */
window.addEventListener('pageshow', function (e) {
  if (!e.persisted) return;
  document.querySelectorAll('header-menu details[open]').forEach(function (d) { d.removeAttribute('open'); });
  document.querySelectorAll('.lvp-hover').forEach(function (k) { k.classList.remove('lvp-hover'); });
  /* yalnız hover-oynatmalı hikaye videoları; manifesto sürekli döngü, dokunma */
  document.querySelectorAll('.lvp-hblok__video').forEach(function (v) {
    if (!v.paused) v.pause();
  });
});
